import rhinoHttp from 'rhino/src/core/http/http.module';
import rhinoClient from 'rhino/src/core/client/client.module';

import * as rnAuthEvents from './auth-events.constants';
import * as rnAuthInterceptor from './auth.interceptor';
import * as rnAuthService from './auth.service';
import * as rnSingSession from './session.singleton';


export default angular.module('rhino.core.auth', [
  rhinoHttp,
  rhinoClient,
])
  .config(authInterceptor)
  .constant(rnAuthEvents.name, rnAuthEvents.default)
  .service(rnAuthInterceptor.name, rnAuthInterceptor.default)
  .service(rnAuthService.name, rnAuthService.default)
  .service(rnSingSession.name, rnSingSession.default)
  .run(runAuth)
  .name;


function authInterceptor($httpProvider) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  $httpProvider.interceptors.push(rnAuthInterceptor.name);
}


function runAuth(rnAuthService) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Don't include this while testing because of problems with extra $http calls
  /* global __TEST__ */
  if (!__TEST__) {
    rnAuthService.validate()
      .catch(() => {
        // no-op - it's ok if we fail validation here. Squelching angular 1.6 unhandled promise rejection.
      });
  }
}
